import {ConversationResource, ConversationStatuses, ConversationStatusList} from "../../classes/Api/Inbox";
import {find} from 'lodash'

export default {
    props: {
        replyMode: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        hideToField: {
            type: Boolean,
            default: false,
        },
        messageDefaults: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    created() {
        this.reset()
    },
    data() {
        return {
            isSending: false,
            message: null,
            assignStatus: find(ConversationStatusList, s => s.value === ConversationStatuses.STATUS_FOLLOW_UP),
            statusList: ConversationStatusList
        }
    },
    watch: {
        messageDefaults: {
            handler(n, o) {
                this.reset()
            },
            deep: true
        }
    },
    computed: {
        defaultContent() {
            // Should be overridden in base child component.
        },
        messageMedium() {
            // Should be overridden in base child component.
        },
        messageRecipients() {
            // Should be overridden in base child component.
        }
    },
    methods: {
        setMessage(message) {
            this.message = message
        },
        reset() {
            this.message = Object.assign({}, {
                to: {},
                from: {},
                content: this.defaultContent,
                message_box: {},
                attachments: [],
            }, this.messageDefaults)

            if (this.onReset) {
                this.onReset()
            }
        },
        send() {
            let promise
            this.isSending = true

            if (typeof this.beforeSend === 'function') {
                this.beforeSend()
            }

            let data = { conversation_status: this.assignStatus.value, }

            data.attachments = this.message.attachments.map(i => {
                return i.id
            })

            if (this.replyMode) {
                let conversation = this.$store.getters['inbox/conversations/conversation']
                promise = ConversationResource.reply(
                    conversation.id, this.messageMedium, this.message.content,
                    {}, data
                )
            } else {
                promise = ConversationResource.start({
                    message_box_id: this.message.message_box.id,
                    recipient: this.messageRecipients,
                    medium: this.messageMedium,
                    content: this.message.content,
                    subject: this.message.subject
                }, {}, data)
            }

            promise.then(r => {
                this.$emit('sent', r.data)
            }).catch(e => {
                if (e.response && e.response.status === 400) {
                    alert(e.response.data.message)
                } else {
                    handleApiError(e)
                }
            })
            .finally(() => {
                this.$store.dispatch('user/badges/update')
                this.isSending = false
            })
        },
    }
}